const secureUrlHelper = (url) => {
    if (url?.startsWith("http://")) {
        return url.replace("http://", "https://");
    }
    return url;
};

export default secureUrlHelper;